export default "__VITE_ASSET__BdcKf_AB__"